import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../utility';

const initialState = {
    sideNavigation: true,
    mSideNavigation: false
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SIDE_NAVIGATION_VISIBLE:
            return updateObject(state, {sideNavigation: true})
        case actionTypes.SIDE_NAVIGATION_HIDDEN:
            return updateObject(state, {sideNavigation: false})
        default: 
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/navigation.js